"use strict";

var formValidation = require("../components/formValidation");
const { pageViewEvent, formSubmitEvents } = require("../helpers/gtmHelpers");

module.exports = {
    triggerPageView: function () {
        const pageType = $(".change-password-wrapper").length ? "Change Password" : "Edit Profile";
        pageViewEvent(pageType);
    },

    submitProfile: function () {
        $("form.edit-profile-form").submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr("action");
            $form.spinner().start();
            $("form.edit-profile-form").trigger("profile:edit", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        location.href = data.redirectUrl;
                        formSubmitEvents("Edit profile form");
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    submitPassword: function () {
        $("form.change-password-form").submit(function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr("action");
            $form.spinner().start();
            $("form.change-password-form").trigger("password:edit", e);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: $form.serialize(),
                success: function (data) {
                    $form.spinner().stop();
                    if (!data.success) {
                        formValidation($form, data);
                    } else {
                        location.href = data.redirectUrl;
                        formSubmitEvents("Change password form");
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },
    /**
    * Changes the placeholder color of select elements when their value changes.
    * Specifically targets elements with the class "placeholder-text" and adds the class "black-color" upon change.
    */
    changeSelectPlaceholder: function () {
        // Change placeholder color on select change for MM
        $(".placeholder-text").on("change", function () {
            $(this).addClass("black-color");
        });
    },

    /**
    * Changes the placeholder text color to black if the placeholder has a value on load.
    * This function selects elements with the class 'placeholder-text' and checks if their value is not null.
    * If the value is not null, it adds the 'black-color' class to the element.
    */
    changePlaceholderOnLoad: function () {
        const $placeholder = $(".placeholder-text");
        if ($placeholder.val() !== "") {
            $placeholder.addClass("black-color");
        }
    }
};
